import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { languages, translationDict } from '../db/translation-dict.js';

export type TranslationDict = typeof translationDict;
clientTranslator.updateDictionary(translationDict, languages); // this could be expanded in the future, but right now we only support german
